// Product media gallery — main image + thumbnail row.
// Progressive enhancement: without JS all images stack. On connect we switch to
// single-image mode and wire the thumbnails. Also responds to variant changes
// dispatched as a `variant:change` event carrying the variant's featured media id.
if (!customElements.get("product-media-gallery")) {
  customElements.define(
    "product-media-gallery",
    class ProductMediaGallery extends HTMLElement {
      constructor() {
        super();
        this.onThumbClick = this.onThumbClick.bind(this);
        this.onVariantChange = this.onVariantChange.bind(this);
      }

      connectedCallback() {
        this.thumbs = Array.from(this.querySelectorAll("[data-thumb-id]"));
        this.items = Array.from(this.querySelectorAll("[data-media-id]"));
        // Only enhance when there's something to switch between.
        if (this.items.length > 1) {
          this.classList.add("is-enhanced");
        }
        this.thumbs.forEach((t) => t.addEventListener("click", this.onThumbClick));
        // Variant changes come from the variant selector (same section root).
        this.section = this.closest("[data-product-section]") || document;
        this.section.addEventListener("variant:change", this.onVariantChange);
      }

      disconnectedCallback() {
        this.thumbs?.forEach((t) => t.removeEventListener("click", this.onThumbClick));
        this.section?.removeEventListener("variant:change", this.onVariantChange);
      }

      onThumbClick(event) {
        const id = event.currentTarget.dataset.thumbId;
        this.setActiveMedia(id);
      }

      onVariantChange(event) {
        const mediaId = event.detail?.featuredMediaId;
        if (mediaId) this.setActiveMedia(String(mediaId));
      }

      setActiveMedia(id) {
        const target = this.items.find((el) => el.dataset.mediaId === String(id));
        if (!target) return;
        this.items.forEach((el) => el.removeAttribute("data-active"));
        target.setAttribute("data-active", "true");
        this.thumbs.forEach((t) => {
          if (t.dataset.thumbId === String(id)) {
            t.setAttribute("aria-current", "true");
          } else {
            t.removeAttribute("aria-current");
          }
        });
      }
    },
  );
}
